// utils/projectValidation.js

export const validateProjectForm = (
  formData,
  imageFiles,
  initialData
) => {
  const errors = {};

  if (!formData.name?.trim()) {
    errors.name = "Vui lòng nhập tên dự án";
  }

  if (!formData.developer?.trim()) {
    errors.developer = "Chủ đầu tư không được để trống";
  }

  if (!formData.location?.trim()) {
    errors.location = "Vui lòng nhập địa chỉ dự án";
  }

  if (!formData.status) {
    errors.status = "Vui lòng chọn trạng thái";
  }

  if (!imageFiles.length && !initialData?.image?.length) {
    errors.imagePreview = "Chọn ảnh cho dự án";
  }

  if (
    formData.url &&
    !/^https?:\/\/.+/i.test(formData.url)
  ) {
    errors.url = "URL không hợp lệ";
  }

  return errors;
};